import React from 'react';
import {Modal as BootstrapModal, ModalHeader, ModalBody} from 'reactstrap';
import {Link} from 'react-router-dom';

import Modal from '../../../../shared/components//Modals/Modal.jsx';
import ResetPasswordForm from '../../Forms/ResetPasswordForm/ResetPasswordForm.jsx';
import SubmitButton from '../../Forms/ResetPasswordForm/SubmitButton.jsx';

import {generate} from '../../../routes.js';

export default class ResetPasswordModal extends Modal {
  constructor(props) {
    super(props);

    this.state = {
      success: false,
      email: ''
    };

    this.close = () => this.props.closeModal();
  }

  onSubmitSuccess = (result, dispatch, props) => {
    this.setState({
      success: true
    });
  }

  render() {
    return (
      <BootstrapModal toggle={this.close} isOpen={this.props.isOpen} className="reset-password-modal">
        <ModalHeader toggle={this.close}>Modifier mon mot de passe</ModalHeader>
        {!this.state.success
          ? <ModalBody>
            <ResetPasswordForm
              user={this.props.user}
              token={this.props.token}
              onSubmitSuccess={this.onSubmitSuccess}/>
            <div className="text-center">
              <SubmitButton className="btn btn-primary mt-3">Modifier mon mot de passe</SubmitButton>
            </div>
          </ModalBody>
          : <ModalBody>
            <div className="callout callout-primary mt-0">
              Votre mot de passe a bien été modifié
            </div>
            <div className="text-center">
              <Link className="btn btn-primary" to={generate({name: 'login'})}>Se connecter</Link>
            </div>
          </ModalBody>
        }
      </BootstrapModal>
    );
  }
}
